<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sdProductTemplates"
        @select-all="handleSelectionChange"
        @select="handleSelectionChange">
      <div slot="toolbar">
        <el-button v-if="editAuth" type="success" @click="$refs.edit.open(0)">新建</el-button>
        <el-button v-if="orderAuth" type="primary" plain @click="createOrder(70)">改造订单</el-button>
        <el-button v-if="orderAuth" type="primary" @click="createOrder(0)">非改造订单</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="产品名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55" :selectable="isRowSelectable"/>
      <el-table-column prop="templateName" label="模板名称">
        <template slot-scope="scope">
          <a @click="$refs.edit.open(scope.row, true)">{{scope.row.templateName}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="产品名称" show-overflow-tooltip/>
      <el-table-column prop="customerName" label="客户" show-overflow-tooltip/>
      <el-table-column prop="statusName" label="状态"/>
      <el-table-column
          v-if="editAuth"
          label="操作"
          align="center"
          width="155"
          fixed="right">
        <template slot-scope="scope">
          <!-- :disabled="isAuth(scope.row)" -->
          <el-button type="primary" @click="$refs.edit.open(scope.row)">
            编辑
          </el-button>
          <el-button type="danger" @click="deleteHandle(scope.row.pkid)">
            删除
          </el-button>
          <el-button v-if="scope.row.status === 10" type="success" @click="changeStatus(scope.row)">
            启用
          </el-button>
          <el-button v-else type="danger" @click="changeStatus(scope.row)">
            禁用
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <template-add ref="edit" @save-success="getList(1)"/>
    <order-edit ref="orderEdit" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import TemplateAdd from "./TemplateAdd.vue";
  import OrderEdit from "../order/OrderEdit.vue";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    name: "TemplateList",
    components: { VmTable, VmSearch, TemplateAdd, OrderEdit },
    data() {
      return {
        constant,
        authName: auth.getUserName(),
        currentUserId: auth.getUserId(),
        selections: [],
        editAuth: this.$auth(660),
        orderAuth: this.$auth(661),
        filter: {
          templateName: "",
          materialName: "",
        },
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      isAuth(data) {
        if (this.authName === "admin") {
          return false;
        } else if (this.currentUserId === data.creatorId) {
          return false;
        } else {
          return true;
        }
      },

      // 判断行是否可选（禁用状态不可选）
      isRowSelectable(row, index) {
        // status为20表示禁用状态，禁用状态不可选
        return row.status !== 10;
      },

      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },

      // 删除
      deleteHandle(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http
            .delete("basic", "sdProductTemplates", pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },

      changeStatus(row) {
        let url;
        if(row.status === 10) {
          // 启用
          url = `sdProductTemplates/status/finish/${row.pkid}`;
        } else {
          // 禁用
          url = `sdProductTemplates/status/plan/${row.pkid}`;
        }
        this.$http
          .get("basic", url)
          .then(() => {
            this.getList(-1);
            this.$message.success(row.status === 10 ? "启用成功" : "禁用成功");
          });
      },

      // 复选框勾选
      handleSelectionChange(val) {
        this.selections = val;
      },

      // 创造订单
      createOrder(orderType) {
        if (this.selections.length === 0) {
          this.$message.warning("请选择要生成订单的模板");
          return;
        }
        const selectedIds = this.selections.map(item => item.pkid);
        this.$refs.orderEdit.open({ templateIds: selectedIds, orderType });
      },
    },
  };
</script>